import { render, staticRenderFns } from "./SettingView.vue?vue&type=template&id=43da403e&scoped=true"
import script from "./SettingView.vue?vue&type=script&lang=js"
export * from "./SettingView.vue?vue&type=script&lang=js"
import style0 from "./SettingView.vue?vue&type=style&index=0&id=43da403e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da403e",
  null
  
)

export default component.exports